<template>
    <v-container v-if="proposalListItems == null">
        <v-container>
            <v-row justify="center" align="center">
                <v-col cols=6>
                    <div class="text-h2 text-center primary--text font-weight-light">
                        Loading Proposal List 
                        <v-progress-circular indeterminate color="primary" class="mr-2" v-on="on"></v-progress-circular>    
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
    <v-container class="max-width-override" v-else>
        <v-container>
            <v-row justify="center" align="center">
                <v-col cols=6>
                    <div class="text-h2 text-center primary--text font-weight-light">Proposal List</div>
                </v-col>
            </v-row>
        </v-container>
        <v-card
            min-width="100%"
            outlined
            class="rounded-card"
        >   
            <v-card-title>
                <v-autocomplete
                    v-model="sortObj"
                    label="Sort Table"
                    prepend-inner-icon="mdi-sort-variant"
                    :items=sortTypes
                    item-text="name"
                    item-value="id"
                    class="pa-0 ma-0"
                    single-line
                    return-object
                    hide-details
                    @change="updateSort(sortObj)"
                >
                </v-autocomplete>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search For Client"
                    single-line
                    hide-details
                  ></v-text-field>
            </v-card-title>
            <v-card-text
            class="pa-0"
            >
                <v-data-table
                    :headers="titles"
                    :items=proposalListItems
                    :item-class="row_classes"
                    :expanded.sync="expanded"
                    item-key="client_id"
                    :search="search"
                    :sort-by=sort
                    :sort-desc=sortDesc
                    :key="detailKey"
                    show-expand
                    class="rounded-bottom pa-2"
                  >
                    
                    <template v-slot:item.proposal_count="{ item }">
                    <v-badge
                        inline
                        color="error"
                        :content=item.proposal_count
                      >
                    </v-badge>
                
                                         
                                  
                    </template>
                    <template v-slot:item.client_name="{ item }">
                            <div class="text-override pr-0 pl-0 font-weight-bold"> {{ item.client_name }} </div>
                      
                    </template>
                    <template v-slot:item.plan_runner_short_name="{ item }">
                            <div class="text-override pr-0 pl-0"><span class="d-none d-xl-inline">Ran</span> For: {{ item.plan_runner_short_name }} </div>
                    </template>
                    <template v-slot:item.probability="{ item }">
                        <v-row class="text-override">
                            <v-col cols="7" class="pr-0 mr-0 text-right">
                                Probability:
                            </v-col>
                            <v-col cols="5" class="pb-3 pt-2">
                                <v-text-field
                                hide-details
                                dense
                                single-line
                                dark
                                v-mask=percentageMask
                                v-model="item.probability"
                                @change="updateHeader(item.probability, 'probability', item)"
                                >
                                </v-text-field>
                                
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.loi="{ item }">
                      <v-row class="text-override">
                            <v-col cols="4" lg=4 xl=2 class="pr-0 mr-0 text-right">
                                LOI:
                            </v-col>
                            <v-col cols="8" lg=8 xl=10 class="pb-3 pt-2">
                                <v-autocomplete
                                hide-details
                                dense
                                single-line
                                dark
                                v-model="item.loi"
                                :items="loiList"
                                item-text="ddl_name"
                                item-id="level_of_involvement_id"
                                return-object
                                @change="updateHeader(item.loi, 'loi',item)"
                                multiple
                                >
                                    <template slot="selection" slot-scope="data">
                                        {{ data.item.name }}, 
                                    </template>
                                </v-autocomplete>
                                
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.follow_up="{ item }">
                        <v-row class="text-override">
                            <v-col cols="5" xl=5 class="pr-0 pl-lg-0 pl-xl-3 mr-0 text-center">
                                Follow<span class="d-inline d-xl-none">:</span><span class="d-none d-xl-inline" >Up:</span>
                            </v-col>
                            <v-col cols="7" class="pb-3 pr-0 pl-0 pl-xl-3 pr-xl-3 pt-2">
                                <v-text-field
                                hide-details
                                dense
                                single-line
                                dark
                                v-model="item.follow_up"
                                @change="updateHeader(item.follow_up, 'follow_up', item)"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.status="{ item }">
                        <v-row class="text-override">
                            <v-col cols="5" xl=4 class="pr-0 mr-0 text-right">
                                Status:
                            </v-col>
                            <v-col cols="7" xl=5 class="pb-3 pt-2 pr-0">
                                <v-autocomplete
                                hide-details
                                dense
                                single-line
                                dark
                                v-model="item.status"
                                :items=statusList
                                item-text="status_name"
                                item-id="status_id"
                                return-object
                                @change="updateHeader(item.status, 'status', item)"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-row align="center">
                            <v-col cols="12" lg=6 xl=4 class="mr-xl-3 pl-lg-0 pt-1 pb-1" >
                                <v-tooltip top v-if="apply_small_buttons">
                                    <template v-slot:activator="{ on }">
                                    <v-btn
                                        fab 
                                        x-small
                                        class="mx-2 pl-0 pr-0"
                                        v-on="on"
                                        elevation=0
                                        @click="addComment(item)"
                                    >
                                        <v-icon color="light-green lighten-1">mdi-comment-plus-outline</v-icon>
                                    </v-btn>
                                    </template>
                                    <span>Add Comment <span> <v-icon color="amber darken-2">mdi-alert-circle-outline</v-icon>Coming Soon!</span></span>
                                </v-tooltip>
                                <v-tooltip top v-else>
                                    <template v-slot:activator="{ on }">
                                    <v-btn
                                        fab 
                                        small
                                        class="mx-2 pl-0 pr-0"
                                        v-on="on"
                                        elevation=0
                                        @click="addComment(item)"
                                    >
                                        <v-icon color="light-green lighten-1">mdi-comment-plus-outline</v-icon>
                                    </v-btn>
                                    </template>
                                    <span>Add Comment <span> <v-icon color="amber darken-2">mdi-alert-circle-outline</v-icon>Coming Soon!</span></span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="12" lg=6 xl=4 class="pl-0 pr-0 pt-xl-3 pb-xl-3 pt-1 pb-1" >
                                <v-dialog
                                    v-model="dialog2"
                                    persistent
                                    :retain-focus="false"
                                    max-width="900px"
                                >
                                    <template v-slot:activator="{ on, attrs }" v-if="apply_small_buttons">
                                        <v-btn 
                                        fab
                                        x-small
                                        color="grey lighten-2"
                                        class="mx-2"
                                        elevation=0
                                        v-bind="attrs"
                                        v-on="{ on }"
                                        @click="addProposal(item)"
                                        >
                                        <v-icon color="primary">mdi-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <template v-slot:activator="{ on, attrs }" v-else >
                                        <v-btn                                        
                                        fab
                                        small
                                        color="grey lighten-2"
                                        class="mx-2"
                                        elevation=0
                                        v-bind="attrs"
                                        v-on="{ on }"
                                        @click="addProposal(item)"
                                        >
                                            <v-icon color="primary">mdi-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <!--
                                    <v-card>
                                        <v-card-text>
                                            <v-container>
                                            <div class="text-h4 font-weight-regular primary--text text-center">Used Revenue Share Programs </div>
                                            </v-container>
                                            <v-container align="center" justify="center" class="text-center">
                                                <v-row>
                                                    <v-col :cols=4 v-for="program in used_rks" :key="program.id">
                                                        <div class="text-h5 font-weight-regular"> {{program}}</div>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                            <v-container>
                                            <div class="text-h4 font-weight-regular primary--text text-center">Select A Revenue Share Program</div>
                                            </v-container>                                                
                                            <v-container>
                                                <v-autocomplete
                                                    v-model="selectedRK"
                                                    label="Select Rev Share Program"
                                                    :items=available_rks
                                                    item-text="rk_name"
                                                    item-value="rk_id"
                                                    outlined
                                                    @change="fetchProviders(selectedRK)"
                                                    hide-details
                                                >
                                                </v-autocomplete>
                                            </v-container>
                                            <v-container v-if="selectedRK !== null">
                                                <v-autocomplete
                                                v-model="selectedRep"
                                                :items=wholesalerList[0].rep_users
                                                item-text="rep_name"
                                                item-value="rep_user_id"
                                                outlined
                                                label="Select Wholesaler Representative"
                                                hide-details
                                                >
                                                </v-autocomplete>
                                            </v-container>
                                            <v-container v-if="selectedRK !== null">
                                                <v-autocomplete
                                                v-model="selectedTemplate"
                                                label="Select Template"
                                                :items=wholesalerList[0].templates
                                                item-text="template_name"
                                                item-value="template_id"
                                                outlined
                                                hide-details
                                                >
                                                    
                                                </v-autocomplete>
                                            </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="primary"
                                            text
                                            @click="dialog2 = false"
                                        >
                                            Close
                                        </v-btn>
                                        <v-btn
                                            color="primary"
                                            text
                                            @click.native="addNewProposalFromList()"
                                        >
                                            Create Proposal
                                        </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                    -->
                                </v-dialog>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:expanded-item="{ item }" light>
                        <td :colspan="titles.length+1">
                            <ProposalListItemDetail :details=item.proposals :object=item v-on:edit=detailAction v-if="item.proposals.length > 0"  />
                            <div class="text-h5 font-weight-regular text-center" v-else>This client has no associated proposals.</div>
                        </td>
                    </template>
                    
                    <template v-slot:item.data-table-expand="{ item, expand, isExpanded }">
                        <v-btn dark class="pa-0" x-small elevation=0 color= "primary" @click="expand(!isExpanded)">
                            <v-icon v-if="isExpanded">mdi-chevron-down</v-icon>
                            <v-icon class="dropdown" v-else>mdi-chevron-down</v-icon>
                        </v-btn>
                    </template>
                    
                  </v-data-table>
                  <div class="table-footer-prepend d-flex pl-2 align-center"> 
                        <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            fab 
                            small
                            color="primary"
                            class="ml-5 mr-3 mx-2"
                            v-on="on"
                            elevation=0
                            @click="exportToExcel"
                          >
                            <v-icon>mdi-export</v-icon>
                          </v-btn>
                        </template>
                        <span>Export To Excel</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            fab 
                            small
                            color="primary"
                            class="mr-3 mx-2"
                            v-on="on"
                            elevation=0
                            to="/clientmanagement"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Add Plan Opportunity</span>
                      </v-tooltip>
                    </div>
            </v-card-text>
        </v-card>
    </v-container>
</template> 

<script>
  import ProposalListItemDetail from '@/components/proposalcomps/ProposalListItemDetail.vue';
  import axios from 'axios'
  import {getInitials} from '@/store/global_helpers/utility.js';
  import {getTPAID} from '@/store/global_helpers/sessionReturn.js';
  import {getAuthHeader} from '@/store/global_helpers/authHeader.js';
  import {mapActions, mapGetters} from 'vuex';
  
  import createNumberMask from 'text-mask-addons/dist/createNumberMask'; 
  const percentMask = createNumberMask({ prefix: '', suffix: '%', allowDecimal: false, includeThousandsSeparator: false, allowNegative: false, });
  
  export default {
    data: () => ({
        on: null,
        detailKey: 0,
        //listItems: null,
        percentageMask: percentMask,
        
        recordKeeperList: [],
        rkarray: [],
        dialog: false,
        dialog2: false,
        
        
        // Used in the proposal list add new proposal button
        addPacket: {
            calculate: true,
            rk_id: null,
            wholesaler_id: null,
            template_id: null
        },
        selectedRK: null,
        selectedRep: null,
        selectedTemplate: null,
        used_rks: [],
        available_rks: [],
        local_packets: [],
        local_proposal: {},
        wholesalerList: [],
        
        
        date: new Date().toISOString().substr(0, 10),
        menu: false,
        modal: false,
        expanded: [],
        search: '',
        sortObj: {id: -1, name: "", value: "", desc: false,},
        sort: [],
        sortDesc: false,
        titles: [
            { 
                text: '', 
                value: 'proposal_count',
                align: 'start',
                sortable: false,
                class: 'text-h6 truncate pl-0',
                width: ''
                // width: '17%'
                // width: this.mobile.client_op,
            },
            { 
                text: '', 
                value: 'client_name',
                align: 'start',
                sortable: false,
                class: 'text-h6 truncate pl-0',
                width: ''
                // width: '17%'
                // width: this.mobile.client_op,
            },
            { 
                text: '', 
                value: 'plan_runner_short_name',
                align: 'start',
                sortable: false,
                class: 'text-h6 truncate pl-0',
                width: ''
                // width: '17%'
                // width: this.mobile.client_op,
            },
            { 
                text: '', 
                value: 'probability',
                align: 'start',
                sortable: false,
                filterable: false,
                class: 'text-h6 truncate',
                width: ''
                // width: '12%'
                // width: this.mobile.probability
            },
            { 
                text: '', 
                value: 'loi',
                align: 'start',
                sortable: false,
                filterable: false,
                class: 'text-h6 truncate',
                width: ''
                // width: '19%'
                // width: this.mobile.loi
            },
            { 
                text: '', 
                value: 'follow_up',
                align: 'start',
                sortable: false,
                filterable: false,
                class: 'text-h6 truncate',
                width: ''
                // width: '19%'
                // width: this.mobile.follow_up
            },
            { 
                text: '', 
                value: 'status',
                align: 'start',
                sortable: false,
                filterable: false,
                class: 'text-h6 truncate',
                width: ''
                // width: '18%'
                // width: this.mobile.status
            },
            { 
                text: '', 
                value: 'action',
                align: 'center',
                sortable: false,
                filterable: false,
                class: 'text-h6 truncate',
                width: ''
                // width: '10%'
                // width: this.mobile.action
            },
        ],
        sortTypes: [
            {   
                id: 0,
                name: "Client - Descending",
                value: "client_name",
                desc: true,
            },    
            {
                id: 1,
                name: "Client - Ascending",
                value: "client_name",
                desc: false,
            },    
            {
                id: 2,
                name: "TPA - Descending",
                value: "tpa",
                desc: true,
            },    
            {
                id: 3,
                name: "TPA - Ascending",
                value: "tpa",
                desc: false,
            },    
            {
                id: 4,
                name: "Follow Up Date - Descending",
                value: "follow_up",
                desc: true,
            },    
            {
                id: 5,
                name: "Follow Up Date - Ascending",
                value: "follow_up",
                desc: false,
            },    
        ]
    }),
    mounted () {
    //   this.printOutProps();
      if(this.mobile !== null && this.mobile !== undefined){
              this.titles[0].width = this.mobile.proposal_count
              this.titles[1].width = this.mobile.client_op
              this.titles[2].width = this.mobile.plan_runner_short_name
              this.titles[3].width = this.mobile.probability
              this.titles[4].width = this.mobile.loi
              this.titles[5].width = this.mobile.follow_up
              this.titles[6].width = this.mobile.status
              this.titles[7].width = this.mobile.action
              let i
              for (i=0; i< this.titles.length; i++){
                  this.titles[i].class = this.mobile.class
              }
          }
    // let entity = {  
    //     id: this.auth.tpaID,
    //     type: 'tpa'
    //   };
    //   // dump return from the getProposalList() vuex store action into single list
    //   this.getProposalList(entity);
    },
    
    computed: {
      ...mapGetters({
        proposalListItems: 'getProposalListItems',
        // used to pass tpa ID to exportProposalList store action
        auth: 'authContext',
        loiList: 'getLoiList',
        statusList: 'getStatusList',
        client: 'readClient',
        proposal: 'proposal',
        planOpportunity: 'planOpportunity',
        // packets: 'packets',
        globalContext: 'globalContext',
      }),
        
      apply_small_buttons(){
          switch (this.$vuetify.breakpoint.name) {
            case 'xs': return true;
            case 'sm': return true;
            case 'md': return true;
            case 'lg': return true;
            case 'xl': return false;
          }
          return null;
      },

      mobile () {
            switch (this.$vuetify.breakpoint.name) {
              case 'xs': return {
                  proposal_count: '5%',
                  client_op: '17%',
                  plan_runner_short_name: '10%',
                  probability: '12%',
                  loi: '19%',
                  follow_up: '19%',
                  status: '18%',
                  action: '10%'
              };
              case 'sm': return {
                  proposal_count: '5%',
                  client_op: '17%',
                  plan_runner_short_name: '10%',
                  probability: '12%',
                  loi: '19%',
                  follow_up: '19%',
                  status: '18%',
                  action: '10%'
              };
              case 'md': return {
                  proposal_count: '5%',
                  client_op: '17%',
                  plan_runner_short_name: '10%',
                  probability: '12%',
                  loi: '19%',
                  follow_up: '19%',
                  status: '18%',
                  action: '10%'
              };
              case 'lg': return {
                  proposal_count: '2%',
                  client_op: '17%',
                  plan_runner_short_name: '8%',
                  probability: '16%',
                  loi: '15%',
                  follow_up: '17%',
                  status: '16%',
                  action: '8%',
                  class: 'truncate'
              }
              case 'xl': return {
                  proposal_count: '5%',
                  client_op: '17%',
                  plan_runner_short_name: '8%',
                  probability: '12%',
                  loi: '17%',
                  follow_up: '15%',
                  status: '18%',
                  action: '12%',
                  class: 'truncate'
              };
            }
            return null
        },
    },
    watch: {      
      proposalListItems(){
          if(this.proposalListItems !== null && this.proposalListItems !== undefined){
            this.alterProposalList()  
          }
      },

      mobile(){
          if(this.mobile !== null && this.mobile !== undefined){
              this.titles[0].width = this.mobile.proposal_count
              this.titles[1].width = this.mobile.client_op
              this.titles[2].width = this.mobile.plan_runner_short_name
              this.titles[3].width = this.mobile.probability
              this.titles[4].width = this.mobile.loi
              this.titles[5].width = this.mobile.follow_up
              this.titles[6].width = this.mobile.status
              this.titles[7].width = this.mobile.action
              let i
              for (i=0; i< this.titles.length; i++){
                  this.titles[i].class = this.mobile.class
              }
          }
      },
    },
    methods: {        
        ...mapActions([
            'exportProposalList',
            'getStatusList',
            'getLoiList', 
            'updateListHeader',
            'getClient', 
            'getProposal',
            'getPlanOpportunity',
            'clearPlanAction',
            'clearProposalList',
            'doCalculationsProposalList',
            'getProposalList',
            'getPackets',
            ]),
        
        exportToExcel () {
          // build entity object for action
          let entity = {
            id: this.auth.tpaID,
            type: 'tpa'
          };
          // returns excel file
          this.exportProposalList(entity);
        },
        
        row_classes(){
            // returns an array of classes to be applied to item rows in data table
            return ['primary', 'text-h5', 'theme--dark', 'pl-0', 'pr-0'];
        },        

        alterProposalList(){
          let i
          for(i=0; i<this.proposalListItems.length; i++){
            this.proposalListItems[i].plan_runner_short_name =  getInitials(this.proposalListItems[i].plan_runner_name);     
          }
      },

      async fetchProviders(rk){
            let data = {
                entity: {
                    id: getTPAID(),
                    type: 'tpa'
                },
                rk_ids: rk
            }
            let authHeader = getAuthHeader();
            axios.get('/wholesaler/ddl/?entity_type='+data.entity.type+"&entity_id="+data.entity.id+"&rk_id="+data.rk_ids, authHeader)
            
            .then((res) => {
                this.wholesalerList = res.data
            })
        },
        
        updateHeader(value, type, item){
            let obj = {};
            obj.plan_opportunity_id = item.plan_opportunity_id;
            obj.status = item.status.status_id;
            obj.follow_up = item.follow_up;
            obj.probability = item.probability.slice(0,-1);
            obj.client_id = item.client_id
            obj.client_name = item.client_name
            obj.duration = item.duration
            obj.lois = item.loi
            this.updateListHeader(obj);
            
        },
        addComment(item){
            console.log('Add Comment Client ID: '+item.client_id);
        },

        addProposal(item){
            console.log(item);
            this.$router.push({
                name: 'clientmanagement'
            })
        },
        
        detailAction(item){
            this.$router.push({
                name: 'proposal',
                params: {
                    showComp: 'Builder',
                    context: item,
                    updateMode: true
                }
            })
        },
        
        updateSort(sortObj){
            this.sort.pop();
            this.sort.push(sortObj.value);
            this.sortDesc = sortObj.desc;
        },
        
        // addNewProposalFromList(){
        //     let calculationObject = {}
        //     calculationObject.plan_opportunity_id = this.planOpportunity.plan_opportunity.plan_opportunity_id
        //     calculationObject.rks = this.packets.packets
        //     calculationObject.proposal = this.packets.proposal
        //     calculationObject.client_id = this.packets.proposal.client_id
        //     calculationObject.plan_runner_id = this.planOpportunity.plan_opportunity.plan_runner_id
        //     this.addPacket.wholesaler_id = this.wholesalerList[0].wholesaler_id
        //     this.addPacket.rk_id = this.selectedRK
        //     this.addPacket.template_id = this.selectedTemplate
        //     this.addPacket.rep_user_id = this.selectedRep
        //     calculationObject.rks.push(this.addPacket)
            
            
        //     delete calculationObject.proposal.proposal_id
        //     delete calculationObject.proposal.proposal_number
        //     delete calculationObject.proposal.file_name
        //     delete calculationObject.proposal.queue_id
        //     delete calculationObject.proposal.queue_status
        //     delete calculationObject.proposal.queue_started
        //     delete calculationObject.proposal.queue_finished
        //     delete calculationObject.proposal.file_path
            
            
        //     this.doCalculationsProposalList(calculationObject)
        //     this.dialog2=false
        //     this.clearPlanAction();
        //     this.detailKey += 1;
        //     // this.$router.go(0)
        // },
    },
    destroyed() {
        console.log("ProposalList.vue destroy")
        this.clearProposalList()
    },
    components: {
        ProposalListItemDetail,
    }
  };
</script>

<style type="text/css" scoped>
    .rounded-card{
        border-radius: 40px !important;
    }
  
    .rounded-bottom{
        border-radius: 0 0 40px 40px;
    }
  
  /*.icon-override{*/
  /*    color:#E6E7E8 !important;*/
  /*}*/
    .theme--light.v-sheet--outlined {
        border: thin solid rgb(0,0,0,30%);
    }
    .no-wrap{
        white-space:nowrap;
    }
    .max-width-override {
        max-width: 100% !important;
    }
    .table-footer-prepend {
      margin-top: -58px;
      height: 58px;
    }
    
    .text-override{
        font-size: 1rem !important;
        color: #E6E7E8 !important;
    }
    
    .dropdown{
        transform: rotate(-180deg);
    }
    .truncate {
        max-width: 1px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
</style>
